// Base
import Image from 'next/image'

// Components
import { Flex, Box } from 'yard-utilities/components'

// Assets
import TripAdvisorLogo from '@images/v25/logos/tripadvisor.svg'
import GoogleRatingLogo from '@images/v25/logos/google-rating.svg'

const LogoBanner = () => {
  return (
    <Box backgroundColor="white" paddingY={{ sm: 32 }}>
      <Flex center gap={{ sm: 32 }}>
        <Image
          src={TripAdvisorLogo}
          alt="TripAdvisor logo"
          width={80}
          height={80}
        />
        <Image
          src={GoogleRatingLogo}
          alt="TripAdvisor logo"
          width={138}
          height={80}
        />
      </Flex>
      <div id="how-it-works-anchor" />
    </Box>
  )
}

export default LogoBanner
